// Latvian-friendly search helpers: strip diacritics and match on word stems
export const norm = (s = "") =>
  s
    .toString()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

export const stems = (query = "") =>
  norm(query)
    .split(/\s+/)
    .filter(Boolean)
    .map((t) => (t.length > 4 ? t.slice(0, t.length - 2) : t));

export const hitsQuery = (text, tokens) => {
  const t = norm(text);
  return tokens.every((s) => t.includes(s));
};
